// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5977) return "js/chunk.npm-async-core-js.6fc4dc5c.js";
	if (chunkId === 230) return "js/chunk.npm-async-intl-segmenter-polyfill-rs.30e64cd0.js";
	if (chunkId === 8335) return "js/chunk.app-async.93e32105.js";
	if (chunkId === 4555) return "js/chunk.4555.f7c0e906.js";
	if (chunkId === 4145) return "js/chunk.4145.ca63fd4b.js";
	if (chunkId === 6204) return "js/chunk.6204.3f5d2982.js";
	if (chunkId === 7956) return "js/chunk.7956.f59b4ebe.js";
	if (chunkId === 1973) return "js/chunk.1973.f249f88c.js";
	if (chunkId === 2389) return "js/chunk.2389.92e52f45.js";
	if (chunkId === 2723) return "js/chunk.2723.33902834.js";
	if (chunkId === 6064) return "js/chunk.6064.de6a1aca.js";
	if (chunkId === 6893) return "js/chunk.6893.6eb050f0.js";
	if (chunkId === 6094) return "js/chunk.6094.f325869b.js";
	if (chunkId === 2107) return "js/chunk.npm-async-@blocksuite.989a210c.js";
	if (chunkId === 170) return "js/chunk.npm-async-swr.f98ddb38.js";
	if (chunkId === 1748) return "js/chunk.1748.435e5d57.js";
	if (chunkId === 1968) return "js/chunk.1968.451bc242.js";
	if (chunkId === 220) return "js/chunk.220.f8355d54.js";
	if (chunkId === 6902) return "js/chunk.npm-async-@dotlottie.728ee29a.js";
	if (chunkId === 421) return "js/chunk.npm-async-html2canvas.ac7782a8.js";
	if (chunkId === 1006) return "js/chunk.npm-async-pdf-lib.a9f26190.js";
	if (chunkId === 2394) return "js/chunk.npm-async-@pdf-lib.28f82ba4.js";
	if (chunkId === 8385) return "js/chunk.npm-async-pako.812fe7c2.js";
	if (chunkId === 8772) return "js/chunk.npm-async-shiki.fb9debdb.js";
	if (chunkId === 9141) return "js/chunk.npm-async-@shikijs.ef669a52.js";
	if (chunkId === 4096) return "js/chunk.npm-async-@lottiefiles.b19c42ee.js";
	if (chunkId === 9296) return "js/chunk.9296.04204087.js";
	if (chunkId === 7719) return "js/chunk.7719.521d1ed2.js";
	if (chunkId === 5725) return "js/chunk.5725.4821a346.js";
	if (chunkId === 6323) return "js/chunk.6323.f5c9288a.js";
	if (chunkId === 1817) return "js/chunk.1817.a4fb30ba.js";
	if (chunkId === 328) return "js/chunk.328.13604b3c.js";
	if (chunkId === 9465) return "js/chunk.npm-async-rxjs.e18db8d2.js";
	if (chunkId === 296) return "js/chunk.296.a50c5c49.js";
	if (chunkId === 819) return "js/chunk.819.c0b6fcea.js";
	if (chunkId === 6797) return "js/chunk.6797.337d0dd8.js";
	if (chunkId === 2402) return "js/chunk.2402.cc6c5f31.js";
	if (chunkId === 1570) return "js/chunk.1570.102ceea1.js";
	if (chunkId === 1565) return "js/chunk.1565.76e7e4d2.js";
	if (chunkId === 7920) return "js/chunk.7920.8d369e30.js";
	if (chunkId === 518) return "js/chunk.518.d2f74aee.js";
	if (chunkId === 9481) return "js/chunk.9481.b4eb0825.js";
	if (chunkId === 5461) return "js/chunk.5461.fed6f1dc.js";
	if (chunkId === 2670) return "js/chunk.2670.3a9980d6.js";
	if (chunkId === 7933) return "js/chunk.auth.ec953908.js";
	if (chunkId === 6803) return "js/chunk.6803.4a90e54d.js";
	if (chunkId === 6258) return "js/chunk.6258.2180c6bf.js";
	if (chunkId === 2772) return "js/chunk.2772.df27d932.js";
	if (chunkId === 4023) return "js/chunk.4023.93c2b1c6.js";
	if (chunkId === 7364) return "js/chunk.7364.32e637bc.js";
	if (chunkId === 7090) return "js/chunk.7090.d550ad51.js";
	if (chunkId === 1643) return "js/chunk.1643.291e6a0a.js";
	if (chunkId === 3941) return "js/worker.658946bb.js";
	// return url for filenames based on template
	return undefined;
};